import React from "react";
import Firebase from "../../../firebasehelper";
import GifCard from "../../HotTopic/GifCard";
import VideoCard from "../../HotTopic/VideoCard";
import UploadCard from "./UploadCard";
import MediaContentViewer from "../../../components/MediaContentViewer";
import {
  GIF_UPLOAD,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
} from "../../../Constants/types";

export default function ContentItem({
  contentItem,
  userType,
  setSelectedContent,
  hex,
  onUploadCardClick,
}) {
  const renderContent = (content, userType) => {
    if (!content) {
      return (
        <UploadCard userType={userType} onClick={onUploadCardClick} hex={hex} />
      );
    }

    switch (content.media_type) {
      case GIF_UPLOAD:
      case IMAGE_UPLOAD:
        return <GifCard item={content} />;
      case VIDEO_UPLOAD:
        return <VideoCard item={content} />;
      case YOUTUBE_URL:
        return (
          <div className="hotVideo-card">
            <div className="background">
              <MediaContentViewer
                media_type={content.media_type}
                media_url={content.media_url}
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const formatPublishTime = (starting_monday) => {
    return (
      Firebase.isObjectTimestamp(starting_monday)
        ? starting_monday.toDate()
        : starting_monday
    ).toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <article className="featured-content__card">
      {contentItem && contentItem.title && (
        <h3 className="featured-content__card-title">{contentItem.title}</h3>
      )}
      {renderContent(contentItem, userType)}
      {contentItem && (
        <div className="featured-content__meta-wrapper">
          <span className="featured-content__time">
            Scheduled for {formatPublishTime(contentItem.starting_monday)}
          </span>
          <button
            className="btn btn-white btn-sm featured-content__remove-button"
            data-toggle="modal"
            data-target="#delete_modal"
            onClick={() => setSelectedContent(contentItem)}
          >
            Remove
          </button>
        </div>
      )}
    </article>
  );
}



// WEBPACK FOOTER //
// ./src/screens/FeaturedContent/components/ContentItem.jsx